// third-party
import { IconApps } from '@tabler/icons-react';
import { FormattedMessage } from 'react-intl';

const icons = {
    IconApps
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const appManagement = {
    id: 'App Management',
    title: <FormattedMessage id="App Management" />,
    icon: icons.IconApps,
    type: 'group',
    children: [
        {
            id: 'App Versions',
            title: <FormattedMessage id="App Versions" />,
            type: 'item',
            url: '/app-versions/list',
            icon: icons.IconApps,
            breadcrumbs: false
        },
    ]
};

export default appManagement;